<template>
  <div>
    総ユーザー数：{{ total }}
  </div>
</template>

<script>
export default {
  created: function () {
    this.$store.dispatch('user/retrieveUsers')
  },

  computed: {
    total: function () {
      return this.$store.state.user.users.length
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
